module.exports = __webpack_public_path__ + "img/public/SiteIcons/zipCodeIcon.svg?400d4d43";